import { ModelSetTransformer, ModelTransformer } from '../common/common.model';

export interface ExtMetricDataListItem {
    userName: string;
    isManager: boolean;
    isSuperGroup: boolean;
    metricID: number;
    metricName: string;
    variance: number;
    actual: number;
    targetValue: number;
    rankOrder: number;
    trendClass: string;
    thresholdClass: string;
    thresholdTitle: string;
}

export interface MetricDataListMetric {
    name: string;
}

interface MetricDataListItem {
    username: string;
    values: any[][];
}

export interface MetricDataList {
    metrics: MetricDataListMetric[];
    user: MetricDataListItem;
    superGroup: MetricDataListItem;
    team: MetricDataListItem[];
}

class MetricDataListItemModelTransformer
    implements ModelTransformer<MetricDataListItem, ExtMetricDataListItem>
{
    transform(model: ExtMetricDataListItem): MetricDataListItem {
        return {
            username: model.userName,
            values: [],
        };
    }
}

class MetricDataListItemModelSetTransformer extends ModelSetTransformer<
    MetricDataListItem,
    ExtMetricDataListItem
> {
    constructor(private readonly _numMetrics: number) {
        super();
    }

    protected newTransformer(): ModelTransformer<
        MetricDataListItem,
        ExtMetricDataListItem
    > {
        return new MetricDataListItemModelTransformer();
    }

    transform(model: ExtMetricDataListItem[]): MetricDataListItem[] {
        const transformer = this.newTransformer();
        const transformed: MetricDataListItem[] = [];
        let transformedItem;
        model.forEach((item, index) => {
            const metricIndex = index % this._numMetrics;
            if (metricIndex === 0) {
                transformedItem = transformer.transform(item);
            }
            transformedItem.values.push({
                variance: item.variance,
                actual: item.actual,
                targetValue: item.targetValue,
            });
            if (metricIndex === this._numMetrics - 1) {
                transformed.push(transformedItem);
            }
        });
        return transformed;
    }
}

export class MetricDataListModelTransformer
    implements ModelTransformer<MetricDataList, ExtMetricDataListItem[]>
{
    transform(model: ExtMetricDataListItem[]): MetricDataList {
        const metrics = [];
        model.forEach((value) => {
            if (
                metrics.find((metric) => metric.name === value.metricName) !==
                undefined
            )
                return;
            metrics.push({
                name: value.metricName,
            });
        });

        const transformer = new MetricDataListItemModelSetTransformer(
            metrics.length,
        );
        const user_ = model.filter((value) => value.isManager);
        const superGroup_ = model.filter((value) => value.isSuperGroup);
        const team_ = model.filter(
            (value) => !value.isManager && !value.isSuperGroup,
        );

        const user = transformer.transform(user_)[0];
        const superGroup = transformer.transform(superGroup_)[0];
        const team = transformer.transform(team_);

        return {
            metrics,
            user,
            superGroup,
            team,
        };
    }
}

export function validateMetricDataList(model: MetricDataList): void {
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    const valid =
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        model != null &&
        model.metrics != null &&
        model.metrics.length !== 0 &&
        model.user != null &&
        model.superGroup != null &&
        model.team != null &&
        model.team.length !== 0;
    if (!valid) {
        throw new Error('MetricDataList not valid');
    }
}
